<template>
  <div class="page page-portugues">
    <Header />
    <vue-headful
      title="Brincando Com as Palavras | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
      description="Brincando Com as Palavras | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
    />
    <section class="banner">
      <b-container class="text-center">
        <div class="banner-img">
          <div class="banner-btn" align-content="center">
            <b-button
              href="https://editoradobrasil.com.br/faleconosco/"
              target="_blank"
            >DÚVIDAS? FALE CONOSCO</b-button>
          </div>
          <img class="img-fluid" alt src="../../assets/anos-iniciais/palavras/topo-palavras.png" />
        </div>
      </b-container>
    </section>
    <section class="carousel text-center">
      <b-container class="carousel-container-text">
        <h2>Brincando Com as Palavras<br>Ensino Fundamental</h2>
        <p>A nova edição traz um conteúdo alinhado à BNCC de forma atraente para o aluno, destacando a ludicidade e tornando o ensino ainda mais interessante e diferenciado.</p>
      </b-container>
      <b-container class="carousel-container-capas text-center">
        <div>
            <slick-carousel v-bind="settings">
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/palavras/1/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-as-palavras-1-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/palavras/2/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-as-palavras-2-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/palavras/3/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-as-palavras-3-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/palavras/4/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-as-palavras-4-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/palavras/5/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-as-palavras-5-la.jpg"
                    alt
                  />
                </a>
              </div>
            </slick-carousel>
          </div>
      </b-container>
    </section>
    <section class="destaques">
      <b-container>
        <h2 class="text-center">Destaques da coleção</h2>
        <ul>
          <li>Contempla 100% à BNCC;</li>
          <li>Obra organizada em unidades que demarcam a progressão da aprendizagem;</li>
          <li>Textos com conteúdos interdisciplinares - que permitem ao aluno aprender estabelecendo conexões com outras disciplinas;</li>
          <li>Traz atividades lúdicas, como jogos, desafios, diagrama de palavras, labirintos etc. Além de apresentar atividades de brincadeiras em duplas, trios ou grupos que estimulam a interação e a socialização;</li>
          <li>Ao final do volume há materiais de recorte e outros recursos a serem utilizados em atividades propostas aos alunos, estimulando o aprendizado de forma lúdica e interativa.</li>
        </ul>
      </b-container>
    </section>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Portugues",
  components: {
    Header,
    "slick-carousel": VueSlickCarousel
  },
  data: () => ({
    settings: {
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      touchThreshold: 3,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        },
        {
          breakpoint: 374,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    }
  }),
  props: {
    msg: String
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../css/_colors.scss";
.page-portugues {
  .menu {
    .menu-ef {
      background: $portugues;
      > a {
        color: white !important;
      }
      span.menu-title::after {
        content: url("../../assets/material-keyboard-arrow-down-white.svg");
      }
    }
  }
  section.banner {
    background-color: $portugues;
  }
  section.carousel {
    background: url("../../assets/ed-infantil/ed-infantil-bg-branco.png");
    background-repeat: no-repeat;
    background-position: top center;
    h2 {
      color: $portugues;
    }
  }
  section.destaques {
    background: $portugues-2
      url("../../assets/anos-iniciais/palavras/bg-destaques.png");
    background-repeat: no-repeat;
    background-position: top center;
    color: white !important;
  }
}
</style>
